import React, { useEffect, useState, useRef } from "react"
import logo from '../assets/img/logo4.jpeg'
import 'bootstrap/dist/css/bootstrap.css';
import { useNavigate } from "react-router-dom";
import styled from 'styled-components'
import { useSelector } from "react-redux";
import SearchListItem from './SearchListItem'
import CartModal from "./CartModal";
import { fetchCart } from "../store/thunk/fetchCart";
import { useDispatch } from "react-redux";
import { addToCart } from "../store/thunk/addToCart";
import { selectUserDetails } from "../Selectors/Selector";
import { logOut, raiseError } from "../store/actions/action";
import { fetchProducts } from "../store/thunk/fetchProducts";


function Header(props) {
    const dispatch = useDispatch();
    const divRef = useRef(null);
    const [showMobileHeader, setShowMobileHeader] = useState(false);
    const [showSearchItems, setShowSearchItems] = useState(false);
    const [searchText, setSearchText] = useState('');

    const Products = useSelector((store) => store.products.data);
    const userDetails = useSelector(selectUserDetails);
    const cartDetails = useSelector((store) => store.cart.data)

    const navigate = useNavigate();
    const onClickLogo = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate('/');
    }
    const onClickMobileCartIcon = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate('/cart')
    }

    const onClickAddToCart = (product) => {
        if (userDetails) {
            let cart = cartDetails.find((item) => item.productId === product.id)
            let cartDetail = {
                UserId: userDetails.id,
                ProductId: Number(product.id),
                Quantity: cart ? cart.quantity + 1 : 1
            }
            dispatch(addToCart(cartDetail));
        }
    }

    const goToCategory = (e, catName) => {
        e.preventDefault();
        if (catName) {
            navigate(`/category/${encodeURIComponent(catName)}`);
        } else {
            navigate('/category');
        }
    };

    const showCategoryPage = (e) => {
        e.preventDefault();
        setShowMobileHeader(false);
        const catName = e.currentTarget.textContent.trim();
        const allItems = ['AllMedicines', 'Featured', 'Popular'];
        if (allItems.includes(catName)) {
            navigate('/category');
        } else {
            navigate(`/category/${encodeURIComponent(catName)}`);
        }
    }

    const onClickAccount = (e) => {
        e.preventDefault();
        setShowMobileHeader(false);
        if(userDetails){
            navigate(`/account/${e.currentTarget.id}`);
        }
        else{
            dispatch(raiseError("Please Login"))
        }
    }

    const onClickOverLay = (e) => {
        e.preventDefault();
        setShowMobileHeader(false);
    }

    const onClickLogin = (e) => {
        e.preventDefault();
        props.setOpenLoginModal(true);
    }

    const onClickRegister = (e) => {
        e.preventDefault();
        props.setOpenRegisterModal(true)
    }

    const handleSearchClick = () => {
        setShowSearchItems(true);
    };
    const onClickLogout = () => {
        const closeMobileHeader = document.getElementById('closeMobileHeader');
        closeMobileHeader.click();
        if(userDetails){
            dispatch(logOut());
            navigate('/');
        }
        else{
            dispatch(raiseError("Please login"));
        }
    }

    const filterByName = (product) => {
        return (
            searchText === '' || product?.name?.toLowerCase().includes(searchText?.toLowerCase())
        );
    }
    // useEffect(() => {
    //     if (userDetails && !cartDetails?.length > 0) {
    //         dispatch(fetchCart(userDetails.id));
    //     }
    // }, [userDetails]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (divRef.current && !divRef.current.contains(event.target)) {
                setShowSearchItems(false);
                console.log('Clicked outside the div');
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!(Products && Products.length > 0)) {
            dispatch(fetchProducts());
        }
        if(userDetails){
            dispatch(fetchCart(userDetails?.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <StyledHeader>
            <div className="header">
                <div className="container-fluid theme-container">
                    <div className="top-header">
                        <div className="row align-items-center">
                            <div className="col-auto">
                                <a href="#" onClick={(e) => onClickLogo(e)}>
                                    <img src={logo} alt="logo" className="header-logo" />
                                </a>
                            </div>
                            <div className="col">
                                <div className="header-search" ref={divRef}>
                                    <form action="#">
                                        <input className="form-control custom-search"
                                            placeholder="Search for Medicines and Health Products." type="text" onChange={(e) => setSearchText(e.target.value)} onClick={() => handleSearchClick()} />
                                    </form>
                                    <div className={showSearchItems ? "search-content" : "search-content d-none"}>
                                        <div className="search-product">
                                            {Products && Products.length > 0 &&
                                                Products.filter(filterByName).map((product) => {
                                                    return (
                                                        <SearchListItem key={product.id} product={product} onClickAddToCart={onClickAddToCart} />
                                                    );
                                                })

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-auto">
                                <ul className="header-right-options">
                                    {!(userDetails) && <div>
                                        <li className="link-item">
                                            <a href="#" className = "linkClass" data-toggle="modal" data-dismiss="modal" data-target="#login_modal" onClick={(e) => onClickLogin(e)}>Login</a>
                                        </li>
                                        <li className="link-item">
                                            <a href="#" className = "linkClass" data-toggle="modal" data-dismiss="modal" data-target="#register_modal" onClick={(e) => onClickRegister(e)}>Register</a>
                                        </li>
                                    </div>
                                    }
                                    <li className="dropdown head-cart-content">
                                        <button id="dropdownCartButton" className="btn dropdown-toggle" type="button"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <div className="list-icon" >
                                                <i className="ti-bag"></i>
                                            </div>
                                            <span className="badge badge-secondary">{cartDetails?.length}</span>
                                        </button>
                                        <CartModal />
                                    </li>
                                    {userDetails && <li className="dropdown">
                                        <button id="dropdownCartButton" className="btn dropdown-toggle" type="button"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <div className="list-icon">
                                                <i className="ti-user"></i>
                                            </div>
                                        </button>

                                        <div className="dropdown-menu dropdown-menu-right user-links"
                                            aria-labelledby="dropdownMenuButton">
                                            <ul>
                                                <li id="accountDetails" onClick={(e) => onClickAccount(e)}>
                                                    <a href="#">
                                                        Account
                                                    </a>
                                                </li>
                                                <li id="changePassword" onClick={(e) => onClickAccount(e)}>
                                                    <a href="#">
                                                        Change Password
                                                    </a>
                                                </li>
                                                <li id="myOrders" onClick={(e) => onClickAccount(e)}>
                                                    <a href="#">
                                                        My Orders
                                                    </a>
                                                </li>
                                                {userDetails?.isAdmin &&
                                                    <div>
                                                        <li id="allOrders" onClick={(e) => onClickAccount(e)}>
                                                            <a href="#">
                                                                Manage Orders
                                                            </a>
                                                        </li>
                                                        <li id="allUsers" onClick={(e) => onClickAccount(e)}>
                                                            <a href="#">
                                                                All Users
                                                            </a>
                                                        </li>
                                                        <li id="addProduct" onClick={(e) => onClickAccount(e)}>
                                                            <a href="#">
                                                                Add Product
                                                            </a>
                                                        </li>
                                                    </div>
                                                }
                                                <li onClick={(e) => onClickLogout(e)}>
                                                    <a href="#">
                                                        Logout
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="header-links">
                        <div className="container-fluid theme-container">
                            <ul className="header-links-container">
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, null)}>
                                            <span className="header-childrenItem-link-text linkClass ">AllMedicines</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Medicines One</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Medicines Two</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Medicines Three</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, 'COVID Prevention')}>
                                            <span className="header-childrenItem-link-text linkClass ">COVID Prevention</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, null)}>
                                            <span className="header-childrenItem-link-text linkClass ">Featured</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul>
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, 'Fitness')}>
                                            <span className="header-childrenItem-link-text linkClass">Fitness</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul>
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, 'Diabetes')}>
                                            <span className="header-childrenItem-link-text linkClass">Diabetes</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul>
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#">
                                            <span className="header-childrenItem-link-text linkClass">COVID Test </span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Boost Your Immunity</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Masks</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, null)}>
                                            <span className="header-childrenItem-link-text linkClass">Popular</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul>
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, 'Supplements')}>
                                            <span className="header-childrenItem-link-text linkClass">Supplements</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul>
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Nutritional Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Adults</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Children</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">For Women</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </li>
                                <li className="header-links-item">
                                    <div className="header-childrenItem-parent">
                                        <a href="#" onClick={(e) => goToCategory(e, 'Nutrition')}>
                                            <span className="header-childrenItem-link-text linkClass">Nutrition</span>
                                        </a>
                                        <i className="fa fa-angle-down drop-icon"></i>
                                    </div>
                                    <div className="header-childrenItem-child-category-links">
                                        <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins &amp;
                                                        Supplements</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Multivitamins</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Vitamins A-Z</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Mineral Supplements</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Flash Deals</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Top Health Products</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Summer Essentials</span>
                                                </a>
                                            </li>
                                            <li><a href="#" className="childItem-level-2">
                                                <span className="header-childrenItem-link-text linkClass">Trending Products</span>
                                            </a>
                                            </li>
                                        </ul>
                                        {/* <ul className="header-childrenItem-child-list">
                                            <li>
                                                <a href="#" className="childItem-level-2">
                                                    <span className="header-childrenItem-link-text linkClass">Health Food &amp; Drinks</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Green Tea &amp; Herbal
                                                        Tea</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Herbal Juice</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Apple Cider Vinegar</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#" className="childItem-level-3">
                                                    <span className="header-childrenItem-link-text linkClass">Healthy Snacks</span>
                                                </a>
                                            </li>
                                        </ul> */}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-header">
                <div className="container-fluid theme-container">
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <ul className="header-left-options" onClick={() => setShowMobileHeader(true)}>
                                <li className="link-item open-sidebar">
                                    <i className="ti-menu"></i>
                                </li>
                            </ul>
                        </div>
                        <div className="col text-center" onClick={(e) => onClickLogo(e)}>
                            <img src={logo} alt="logo" className="header-logo" />
                        </div>
                        <div className="col-auto">
                            <ul className="header-right-options">
                                <li className="link-item" onClick={(e) => onClickMobileCartIcon(e)}>
                                    <span className="badge badge-secondary">{cartDetails?.length}</span>
                                    <i className="ti-bag"></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className={showMobileHeader ? "menu-sidebar show" : "menu-sidebar"}>
                        <div className="close" id='closeMobileHeader' onClick={() => setShowMobileHeader(false)}>
                            <i className="ti-close"></i>
                        </div>

                        <div className="welcome d-flex align-items-center">
                            {!userDetails ? <div>
                                <a href="#" data-toggle="modal" data-dismiss="modal" data-target="#login_modal" className="btn btn-soft-primary btn-md" onClick={onClickLogin}>Login</a>
                                <a href="#" data-toggle="modal" data-dismiss="modal" data-target="#register_modal" className="btn btn-primary btn-md" onClick={onClickRegister}>Register</a> </div>
                                : <div><div className="avater btn-soft-primary">{userDetails?.firstName?.charAt(0)}</div>
                                    <span>{`Hi, ${userDetails.firstName}`}</span></div>
                            }
                        </div>
                        <div className="mobileMenuLinks mb-4 mt-2">
                            <h6>Account Info</h6>
                            <ul>
                                <li id="accountDetails" onClick={(e) => onClickAccount(e)}>
                                    <a href="#">
                                        Account
                                    </a>
                                </li>
                                <li id="changePassword" onClick={(e) => onClickAccount(e)}>
                                    <a href="#">
                                        Change Password
                                    </a>
                                </li>
                                <li id="myOrders" onClick={(e) => onClickAccount(e)}>
                                    <a href="#">
                                        My Orders
                                    </a>
                                </li>
                                {userDetails?.isAdmin &&
                                    <div>
                                        <li id="allOrders" onClick={(e) => onClickAccount(e)}>
                                            <a href="#">
                                                All Orders
                                            </a>
                                        </li>
                                        <li id="allUsers" onClick={(e) => onClickAccount(e)}>
                                            <a href="#">
                                                All Users
                                            </a>
                                        </li>
                                        <li id="addProduct" onClick={(e) => onClickAccount(e)}>
                                            <a href="#">
                                                Add Product
                                            </a>
                                        </li>
                                    </div>
                                }
                                <li onClick={(e) => onClickLogout(e)}>
                                    <a href="#">
                                        Logout
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <div className="mobileMenuLinks">
                            <h6>Category</h6>
                            <ul>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)} >AllMedicines</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >COVID Prevention</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >Featured</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >Fitness</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)} >Diabetes</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >COVID Test </a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >Popular</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)} >Supplements</a></li>
                                <li><a href="#" onClick={(e) => showCategoryPage(e)}  >Nutrition</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={showMobileHeader ? "overlay show" : "overlay"} onClick={(e) => onClickOverLay(e)}></div>
                {/* {showSearchItems && (
                    <div className="search_overlay" ></div>
                )} */}
            </div>
        </StyledHeader>
    );
}
export default Header

const StyledHeader = styled.div`
  /* ════════════════════════════════════════════════
     Design tokens
     ════════════════════════════════════════════════ */
  --ph-font: 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  --ph-blue:       #2563eb;
  --ph-blue-dark:  #1d4ed8;
  --ph-blue-light: #eff6ff;
  --ph-text-1:     #0f172a;   /* headings / labels */
  --ph-text-2:     #475569;   /* body / nav items  */
  --ph-text-3:     #94a3b8;   /* placeholders / carets */
  --ph-border:     #e2e8f0;
  --ph-surface:    #f8fafc;

  font-family: var(--ph-font);

  /* ════════════════════════════════════════════════
     Outer shell
     ════════════════════════════════════════════════ */
  .header {
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 1000;
    border-top: none !important;
    /* layered shadow: hard edge + soft ambient */
    box-shadow:
      0 1px 0 var(--ph-border),
      0 4px 16px rgba(15, 23, 42, 0.04);
  }

  /* 2-px gradient top rule — brand identity strip */
  .header::before {
    content: '';
    display: block;
    height: 2px;
    background: linear-gradient(90deg, #2563eb 0%, #06b6d4 50%, #10b981 100%);
  }

  /* ════════════════════════════════════════════════
     Top row  (logo · search · auth · cart)
     ════════════════════════════════════════════════ */
  .top-header {
    padding: 14px 0 !important;
  }

  /* Logo */
  .header-logo {
    height: 44px !important;
    width: auto !important;
    object-fit: contain;
    display: block;
    transition: opacity 0.15s ease !important;
  }
  .header-logo:hover { opacity: 0.85 !important; }

  /* ── Search ── */
  .form-control.custom-search {
    border-radius: 10px !important;
    height: 42px !important;
    border: 1.5px solid var(--ph-border) !important;
    padding: 0 48px 0 18px !important;
    font-size: 13.5px !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.01em !important;
    background: var(--ph-surface) !important;
    color: var(--ph-text-1) !important;
    box-shadow: none !important;
    transition:
      border-color 0.18s ease,
      box-shadow   0.18s ease,
      background   0.18s ease !important;
  }

  .form-control.custom-search::placeholder {
    color: var(--ph-text-3) !important;
    font-weight: 400 !important;
  }

  .form-control.custom-search:focus {
    border-color: var(--ph-blue) !important;
    background: #ffffff !important;
    box-shadow:
      0 0 0 3px rgba(37, 99, 235, 0.12),
      0 1px 4px rgba(37, 99, 235, 0.08) !important;
    outline: none !important;
  }

  /* Search results dropdown */
  .search-content:not(.d-none) {
    border-radius: 14px;
    border: 1px solid var(--ph-border);
    box-shadow:
      0 4px 6px rgba(15, 23, 42, 0.04),
      0 16px 48px rgba(15, 23, 42, 0.10);
    margin-top: 6px;
  }

  .search-content:not(.d-none) .search-product {
    max-height: 400px;
    overflow-y: auto;
  }

  /* ── Auth buttons ── */
  .header-right-options {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    padding: 0 !important;
    margin: 0 !important;
    list-style: none !important;
  }

  /* Login — refined ghost */
  .header-right-options > div > .link-item:first-child .linkClass {
    display: inline-flex !important;
    align-items: center !important;
    height: 36px !important;
    padding: 0 16px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.015em !important;
    color: var(--ph-text-2) !important;
    border: 1.5px solid var(--ph-border) !important;
    border-radius: 8px !important;
    text-decoration: none !important;
    background: #ffffff !important;
    transition: border-color 0.18s, color 0.18s, background 0.18s !important;
    white-space: nowrap !important;
  }

  .header-right-options > div > .link-item:first-child .linkClass:hover {
    border-color: var(--ph-blue) !important;
    color: var(--ph-blue) !important;
    background: var(--ph-blue-light) !important;
    text-decoration: none !important;
  }

  /* Register — solid primary with glow */
  .header-right-options > div > .link-item:last-child .linkClass {
    display: inline-flex !important;
    align-items: center !important;
    height: 36px !important;
    padding: 0 18px !important;
    font-size: 13px !important;
    font-weight: 600 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.015em !important;
    color: #ffffff !important;
    background: var(--ph-blue) !important;
    border: 1.5px solid var(--ph-blue) !important;
    border-radius: 8px !important;
    text-decoration: none !important;
    box-shadow: 0 1px 3px rgba(37, 99, 235, 0.35) !important;
    transition: background 0.18s, box-shadow 0.18s, transform 0.12s !important;
    white-space: nowrap !important;
  }

  .header-right-options > div > .link-item:last-child .linkClass:hover {
    background: var(--ph-blue-dark) !important;
    border-color: var(--ph-blue-dark) !important;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.38) !important;
    transform: translateY(-1px) !important;
    text-decoration: none !important;
  }

  .header-right-options > div > .link-item:last-child .linkClass:active {
    transform: translateY(0) !important;
    box-shadow: 0 1px 3px rgba(37, 99, 235, 0.35) !important;
  }

  /* ── Cart icon button ── */
  .head-cart-content > .btn.dropdown-toggle {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    height: 40px !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 10px !important;
    position: relative !important;
    padding: 0 !important;
    transition: background 0.18s !important;
  }

  .head-cart-content > .btn.dropdown-toggle:hover {
    background: var(--ph-surface) !important;
  }

  .head-cart-content > .btn.dropdown-toggle::after {
    display: none !important;
  }

  .head-cart-content .list-icon {
    line-height: 1 !important;
  }

  .head-cart-content .ti-bag {
    font-size: 20px !important;
    color: var(--ph-text-1) !important;
    display: block !important;
  }

  .head-cart-content .badge-secondary {
    position: absolute !important;
    top: 4px !important;
    right: 4px !important;
    background: #ef4444 !important;
    color: #ffffff !important;
    border-radius: 20px !important;
    font-size: 9px !important;
    font-weight: 700 !important;
    min-width: 16px !important;
    height: 16px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 3px !important;
    border: 2px solid #ffffff !important;
    line-height: 1 !important;
  }

  /* ── User icon button ── */
  .header-right-options > li.dropdown > .btn.dropdown-toggle {
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 40px !important;
    height: 40px !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    border-radius: 10px !important;
    padding: 0 !important;
    transition: background 0.18s !important;
  }

  .header-right-options > li.dropdown > .btn.dropdown-toggle:hover {
    background: var(--ph-surface) !important;
  }

  .header-right-options > li.dropdown > .btn.dropdown-toggle::after {
    display: none !important;
  }

  .header-right-options > li.dropdown .ti-user {
    font-size: 20px !important;
    color: var(--ph-text-1) !important;
  }

  /* ── User dropdown menu ── */
  .user-links {
    border-radius: 14px !important;
    border: 1px solid var(--ph-border) !important;
    box-shadow:
      0 4px 6px rgba(15, 23, 42, 0.04),
      0 16px 48px rgba(15, 23, 42, 0.10) !important;
    padding: 8px !important;
    min-width: 192px !important;
    margin-top: 6px !important;
  }

  .user-links ul {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .user-links li { list-style: none !important; }

  .user-links li a {
    display: flex !important;
    align-items: center !important;
    padding: 9px 12px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.01em !important;
    color: var(--ph-text-2) !important;
    text-decoration: none !important;
    border-radius: 8px !important;
    transition: background 0.14s, color 0.14s !important;
  }

  .user-links li a:hover {
    background: var(--ph-blue-light) !important;
    color: var(--ph-blue) !important;
    text-decoration: none !important;
  }

  /* ════════════════════════════════════════════════
     Nav bar  (category links)
     ════════════════════════════════════════════════ */
  .header-links {
    border-top: 1px solid var(--ph-border) !important;
    background: #ffffff !important;
  }

  .header-links .container-fluid { padding: 0 !important; }

  .header-links-container {
    display: flex !important;
    align-items: stretch !important;
    list-style: none !important;
    margin: 0 !important;
    padding: 0 4px !important;
    gap: 0 !important;
    flex-wrap: nowrap !important;
  }

  .header-links-item {
    position: relative !important;
    list-style: none !important;
    display: flex !important;
    align-items: center !important;
  }

  /* Nav trigger */
  .header-childrenItem-parent {
    display: flex !important;
    align-items: center !important;
    gap: 5px !important;
    padding: 10px 12px !important;
    cursor: pointer !important;
    border-radius: 0 !important;
    transition: color 0.18s ease !important;
    white-space: nowrap !important;
    user-select: none !important;
    border-bottom: 2px solid transparent !important;
    margin-bottom: -1px !important; /* sit on the border-top of .header-links */
  }

  .header-childrenItem-parent a { text-decoration: none !important; }

  .header-links-item:hover .header-childrenItem-parent {
    border-bottom-color: var(--ph-blue) !important;
    background: transparent !important;
  }

  /* Nav text */
  .header-childrenItem-link-text.linkClass {
    font-size: 13px !important;
    font-weight: 500 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.015em !important;
    color: var(--ph-text-2) !important;
    text-decoration: none !important;
    transition: color 0.18s !important;
  }

  .header-links-item:hover .header-childrenItem-link-text.linkClass {
    color: var(--ph-blue) !important;
  }

  /* Caret chevron */
  .drop-icon {
    font-size: 9px !important;
    color: var(--ph-text-3) !important;
    transition: transform 0.22s ease, color 0.18s !important;
    margin-top: 1px !important;
  }

  .header-links-item:hover .drop-icon {
    transform: rotate(180deg) !important;
    color: var(--ph-blue) !important;
  }

  /* ════════════════════════════════════════════════
     Dropdown menus
     ════════════════════════════════════════════════ */
  .header-childrenItem-child-category-links {
    border-radius: 16px !important;
    border: 1px solid var(--ph-border) !important;
    box-shadow:
      0 4px 6px rgba(15, 23, 42, 0.04),
      0 20px 60px rgba(15, 23, 42, 0.12) !important;
    padding: 16px !important;
    min-width: 220px !important;
    margin-top: 0 !important;
    background: #ffffff !important;
    animation: phDropIn 0.18s cubic-bezier(0.16, 1, 0.3, 1) !important;
    top: 100% !important;
  }

  @keyframes phDropIn {
    from { opacity: 0; transform: translateY(6px) scale(0.98); }
    to   { opacity: 1; transform: translateY(0)   scale(1);    }
  }

  .header-childrenItem-child-list {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .header-childrenItem-child-list li {
    list-style: none !important;
    padding: 0 !important;
  }

  /* Section heading (level-2) */
  .childItem-level-2 {
    display: block !important;
    padding: 8px 10px 6px !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.08em !important;
    text-transform: uppercase !important;
    color: var(--ph-text-3) !important;
    text-decoration: none !important;
    border-radius: 0 !important;
    white-space: nowrap !important;
    margin-top: 10px !important;
    transition: color 0.14s !important;
  }

  .childItem-level-2:first-child { margin-top: 0 !important; }

  .childItem-level-2:hover {
    color: var(--ph-blue) !important;
    background: transparent !important;
    text-decoration: none !important;
  }

  /* Sub-item (level-3) */
  .childItem-level-3 {
    display: block !important;
    padding: 7px 10px !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    font-family: var(--ph-font) !important;
    letter-spacing: 0.01em !important;
    color: var(--ph-text-2) !important;
    text-decoration: none !important;
    border-radius: 8px !important;
    transition: background 0.14s, color 0.14s !important;
    white-space: nowrap !important;
  }

  .childItem-level-3:hover {
    background: var(--ph-blue-light) !important;
    color: var(--ph-blue) !important;
    text-decoration: none !important;
  }

  /* Pass colour/weight through to the inner span */
  .childItem-level-2 .header-childrenItem-link-text,
  .childItem-level-3 .header-childrenItem-link-text {
    color: inherit !important;
    font-size: inherit !important;
    font-weight: inherit !important;
    letter-spacing: inherit !important;
    text-transform: inherit !important;
  }
`;